module.exports = __webpack_public_path__ + "static/Logo-6fa11873170c27f9b8da6ba5d832ca1b.png";